import { render, staticRenderFns } from "./RawMaterialsView.vue?vue&type=template&id=cd40170a&scoped=true&"
import script from "./RawMaterialsView.vue?vue&type=script&lang=js&"
export * from "./RawMaterialsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd40170a",
  null
  
)

export default component.exports